import * as React from 'react'
import { SVGProps } from 'react'
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg height={408} viewBox="0 0 408 408" width={408} {...props}>
    <path d="m204 0-35.7 35.7 142.8 142.8H0v51h311.1L168.3 372.3 204 408l204-204z" />
  </svg>
)
export default SvgArrowRight
